import { FormLabel, Radio, RadioGroup, Stack, Text } from "@chakra-ui/react";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { TenantRole, UserRead } from "@nens/rana/api-v1";
import { RanaModal } from "@nens/ranalib";
import { RanaErrors } from "@nens/ranalib";

import { userRoleDescriptionString, userRoleString } from "@/translations";

import { useUpdateUsers } from "../api/update-tenant-user";

interface TenantUserEditableRoleModalProps {
  user: UserRead;
  onClose: () => void;
}

type Role = NonNullable<UserRead["role"]>;

export function TenantUserEditableRoleModal({ user, onClose }: TenantUserEditableRoleModalProps) {
  const [role, setRole] = useState(user.role ?? undefined);

  const intl = useIntl();
  const { mutate, errors, isMutating } = useUpdateUsers([user.id]);

  const saveRole = () => {
    if (role)
      mutate(
        { role },
        {
          onSuccess: onClose,
        }
      );
  };

  return (
    <RanaModal
      isOpen
      onClose={onClose}
      topBar={
        <FormattedMessage
          id="title.edit_organisation_role"
          defaultMessage="Edit organisation role"
        />
      }
      buttons={[
        {
          children: intl.formatMessage({
            id: "button.cancel",
            defaultMessage: "Cancel",
          }),
          variant: "secondary",
          isDisabled: isMutating,
          onClick: onClose,
        },
        {
          children: intl.formatMessage({
            id: "button.save",
            defaultMessage: "Save",
          }),
          variant: "primary",
          isDisabled: isMutating || role === user.role,
          onClick: saveRole,
        },
      ]}
    >
      <RadioGroup onChange={(newRole: Role) => setRole(newRole)} value={role}>
        <Stack>
          {Object.values(TenantRole).map((role) => (
            <Radio key={role} value={role}>
              <FormLabel as="strong">{userRoleString(intl, role)}</FormLabel>
              <Text>{userRoleDescriptionString(intl, role)}</Text>
            </Radio>
          ))}
        </Stack>
      </RadioGroup>
      <RanaErrors errors={errors} />
    </RanaModal>
  );
}
